module.exports = __webpack_public_path__ + "img/avatar0.28fc2ae6.png";